import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Faq.css";
import ProgressLoader from "../Loader/ProgressLoader";
import { Link } from "react-router-dom";

const Faq = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Home_Faq",
        {
          timeout: 5000 
        }
      );
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      setFetchedData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching FAQ data:", error);
      setError(error.message || "Failed to load FAQ data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (error) {
    return (
      <>
        <div className="faq-container py-5">
          <div className="container">
            <h1 className="text-center mb-4">Frequently Asked Questions</h1>
            <div className="alert alert-danger">
              Error loading FAQ: {error}. Please try again later.
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="faq-container py-5">
        <div className="container py-5">
          <h1 className="text-center mb-4">Frequently Asked Questions</h1>
          <p className="text-muted text-center mb-5">
            Find answers to some of the most commonly asked questions below.
          </p>

          {loading ? (
            <div className="text-center">
              {/* <div className="spinner-border text-primary" role="status"> */}
              {/* </div> */}
              <p className="mt-2">Loading FAQs...</p>
              <ProgressLoader />
            </div>
          ) : fetchedData.length === 0 ? (
            <div className="alert alert-info">
              No FAQs available at the moment.
            </div>
          ) : (
            <div className="accordion py-5" id="faqAccordion">
              {fetchedData.map((item) => (
                <div className="accordion-item" key={item.id}>
                  <h2 className="accordion-header" id={`heading${item.id}`}>
                    <button
                      className="accordion-button collapsed" // Added 'collapsed' class
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${item.id}`}
                      aria-expanded="false"
                      aria-controls={`collapse${item.id}`}
                    >
                      {item.title || "Untitled FAQ"}
                    </button>
                  </h2>
                  <div
                    id={`collapse${item.id}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`heading${item.id}`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      {item.description || "No description available"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="text-center mt-5">
            <p className="text-muted">
              If you have more questions, feel free to{" "}
              <Link to="/contactus" className="faq-link">
                contact us
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;